import http from '@/services/api';

const RESOURCE_NAME = 'api/login';

export default {
  login(options) {
    sessionStorage.removeItem('sessionId');
    return http.post(RESOURCE_NAME, null, options);
  }
};
